function* iterateUrls(content: string): Generator<string> {
  const regex =
    /(?:^|\s|[^\w\p{L}/])(?<url>((https?:\/\/)|(www\.))[\w\p{L}-]+(?:\.[\w\p{L}-]+)+(?:[\w\p{L}.,@?^=%&:/~+#()-]*[\w\p{L}/)])?)/giu;

  let match;
  while ((match = regex.exec(content)) !== null) {
    let url = match.groups?.url;
    if (!url) continue;

    const urlIndex = match.index + match[0].indexOf(url);

    // Check if this URL is part of a markdown image syntax: ![...](url)
    const beforeUrl = content.substring(0, urlIndex);
    const imageMarkdownPattern = /!\[[^\]]*\]\(\s*$/;
    if (imageMarkdownPattern.test(beforeUrl)) continue;

    // Strip unbalanced trailing closing parentheses, while preserving parens
    // that are balanced inside the URL itself (e.g. .../P10_QE(2026)000877.pdf).
    while (url.endsWith(")")) {
      const openCount = (url.match(/\(/g) || []).length;
      const closeCount = (url.match(/\)/g) || []).length;
      if (closeCount > openCount) {
        url = url.slice(0, -1);
      } else {
        break;
      }
    }

    yield url;
  }
}

export default function extractUrl(content: string): string | null {
  for (const url of iterateUrls(content)) {
    return url;
  }
  return null;
}

export function extractAllUrls(content: string): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const url of iterateUrls(content)) {
    if (!seen.has(url)) {
      seen.add(url);
      result.push(url);
    }
  }
  return result;
}
